import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetSingleEmailRecord: false,
  getSingleEmailRecordMessage: '',
  getSingleEmailRecordFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function emailRecordReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.GET_SINGLE_EMAIL_RECORD_PENDING:
      return {
        ...globalState,
        isLoadingGetSingleEmailRecord: true,
      };
    case actionTypes.GET_SINGLE_EMAIL_RECORD_FULFILLED:
      return {
        ...globalState,
        isLoadingGetSingleEmailRecord: false,
        getSingleEmailRecordMessage: action.data,
        getSingleEmailRecordFailed: '',
      };
    case actionTypes.GET_SINGLE_EMAIL_RECORD_FAILURE:
      return {
        ...globalState,
        isLoadingGetSingleEmailRecord: false,
        getSingleEmailRecordMessage: '',
        getSingleEmailRecordFailed: action.error,
      };
    default:
      return globalState;
  }
}
export { emailRecordReducer as default };
